<template lang="html">
  <b-container>
    <b-row>
      <b-col v-if="data_loading_inprogress" class="mt-3 mb-4">
        <div class="d-flex justify-content-center mb-3 mt-5">
          <h4>
            Locating Soundslides data file from web location ...
          </h4>
        </div>
        <div class="d-flex justify-content-center mb-3 mt-5">
          <b-spinner
            style="width: 3rem; height: 3rem;"
            type="grow"
            size="lg"
            variant="primary"
          />
        </div>
      </b-col>
      <b-col v-if="!data_loading_inprogress">
        <h1>Import from URL ✨</h1>
        <b-input-group size="lg">
          <b-form-input v-model="url" />
        </b-input-group>
        <p class="mt-3">
          <b-button class="mb-1 mr-1" @click="findDataFile">Load</b-button>
          <span v-if="false">
            <b-button class="mb-1 mr-1" @click="findDataFile(true)">
              Load by txt
            </b-button>
            <b-button class="mb-1 mr-1" @click="findDataHead">Head</b-button>
          </span>
        </p>
        <p v-if="data_loading_error" class="alert">
          We could not find a Soundslides slide show at this URL.
        </p>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import { db } from "@/fstore";

import axios from "axios";
import { processXmlDataToShow } from "@/utils/legacyData";
import { processTxtDataToShow } from "@/utils/legacyData";
import map from "lodash/map";
//import each from "lodash/each";
export default {
  name: "ShowImportFromURL",

  data() {
    return {
      show: {},
      show_bound: false,
      url: "",
      verified_data_path: null,
      data_loading_inprogress: false,
      data_loading_error: false
    };
  },
  computed: {
    id() {
      return this.$route.params.id;
    }
  },
  mounted() {
    console.log("EditorImportUploader", this.id);
    var _v = this;
    db.collection("editor_shows")
      .doc(_v.id)
      .get()
      .then(
        function(doc) {
          console.log("Current data: ", doc.data());
          _v.show = doc.data();

          if (_v.show.import_by_url_complete) {
            // Go to importer.
            _v.go_to_importer();
          }
          if (_v.show.import_by_url && !_v.show.import_by_url_complete) {
            _v.go_to_importer();
          }
          _v.show_bound = true;
        },
        function(error) {
          console.log(error);
        }
      );
  },
  methods: {
    processXml(xmlstring) {
      processXmlDataToShow(this.show, xmlstring);
      this.$store.dispatch("editor/updateShowData", this.show);
      this.checkForFiles();
    },
    processTxt(txtstring) {
      processTxtDataToShow(this.show, txtstring);
      this.$store.dispatch("editor/updateShowData", this.show);
      this.checkForFiles();
    },
    checkForImage(filename, folder_name) {
      // Check for fullscreen. then custom, then 600_450
      var _v = this;
      var image_path = this.verified_data_path + folder_name + "/" + filename;
      var importer_head_check =
        "https://importer-v1-to-v3.soundslides.com/data/head";
      axios
        .post(importer_head_check, {
          url: image_path
        })
        .then(response => {
          console.log(response);
          if (response.data.status_code == 200) {
            console.log("Image found", folder_name);
            _v.createShowAndStartImport();
          } else if (folder_name == "fullscreen") {
            _v.checkForImage(filename, "custom");
          } else if (folder_name == "custom") {
            _v.checkForImage(filename, "600_450");
          } else {
            console.log("No suitable image found!");
          }
        });
    },
    checkForFiles() {
      // Check for the first image only.
      // This is the bare minimum to confirm the pathing.
      this.checkForImage(this.show.data.slideArray[0].file, "fullscreen");
    },
    findDataFile(look_for_txt_file) {
      var _v = this;
      var importer_url = "https://importer-v1-to-v3.soundslides.com/data";
      // importer_url = "http://127.0.0.1:5000/data";

      var url_to_data = this.url;

      // Remove index.html if present.
      if (url_to_data.endsWith("/index.html")) {
        url_to_data = url_to_data.split("/index.html")[0];
      }

      // Remove index.htm if present.
      if (url_to_data.endsWith("/index.htm")) {
        url_to_data = url_to_data.split("/index.htm")[0];
      }

      if (!url_to_data.endsWith("/")) {
        url_to_data = url_to_data + "/";
      }

      var url_to_data_file;
      if (look_for_txt_file == true) {
        url_to_data_file = url_to_data + "soundslide.txt";
      } else {
        url_to_data_file = url_to_data + "soundslide.xml";
      }
      console.log("url_to_data_file", url_to_data_file);
      _v.data_loading_inprogress = true;
      axios
        .post(importer_url, {
          url: url_to_data_file
        })
        .then(response => {
          console.log(response);
          console.log("look_for_txt_file", look_for_txt_file);

          if (response.data.status_code != 200) {
            console.log("Nothing was found.");

            _v.data_loading_inprogress = false;
            _v.data_loading_error = true;

            if (look_for_txt_file != true) {
              // Retry it for txt file.
              _v.findDataFile(true);
            }
            return;
          }

          if (response.data.content.startsWith("<?xml")) {
            this.verified_data_path = url_to_data;
            _v.processXml(response.data.content);
            return;
          }
          if (response.data.content.startsWith("p=")) {
            this.verified_data_path = url_to_data;
            _v.processTxt(response.data.content);
            return;
          }

          if (!look_for_txt_file) {
            // Retry it for txt file.
            _v.findDataFile(true);
          }
        })
        .catch(e => {
          console.log(e);
          _v.data_loading_error = true;
          _v.data_loading_inprogress = false;
        });
    },
    findDataHead() {
      var importer_url = "https://importer-v1-to-v3.soundslides.com/data/head";
      // importer_url = "http://127.0.0.1:5000/data/head";
      axios
        .post(importer_url, {
          url: this.url
        })
        .then(response => {
          console.log(response);
        });
    },
    go_to_importer() {
      var _v = this;
      _v.$router.push({
        name: "show-import",
        params: { id: _v.show.key }
      });
    },
    send_importer_sns() {
      // At this point, call the https://importer-v1-to-v3.soundslides.com/import/{$show_key}
      // You likely will need to poll it a few times, as there is a likely race condition between
      // all the lambdas, and Firestore.
      console.log("send_importer_sns");
      var _v = this;
      this.waiting_for_importer = true;

      var show_key = this.show.key;
      var importer_url =
        "https://importer-v1-to-v3.soundslides.com/import/" + show_key + "/sns";
      //importer_url = "http://127.0.0.1:5000/import/" + show_key + "/sns";
      axios
        .get(importer_url)
        .then(response => {
          console.log("response", response);
          _v.go_to_importer();
        })
        .catch(response => {
          console.log("response", response);
          _v.error = true;
          _v.error_message = "An undefined error occurred.";
        });
    },
    createShowAndStartImport() {
      // Save id to FB.
      var _v = this;
      var has_audio = true;
      if (_v.show.data.displaySettings.noAudio) {
        // No audio.
        has_audio = false;
      }
      console.log("complete!");
      var import_by_url_path = this.verified_data_path;
      if (import_by_url_path.endsWith("/")) {
        // No trailing slash on import_by_url_path;
        import_by_url_path = import_by_url_path.slice(0, -1);
      }
      var show_key = this.show.key;
      var update_obj = {};
      update_obj.key = show_key;
      update_obj.import_by_url = true;
      update_obj.import_by_url_path = import_by_url_path;
      update_obj.import_by_url_inprogress = false;
      update_obj.import_by_url_complete = false;
      update_obj.import_by_url_has_audio = has_audio;
      update_obj.import_by_url_skip_zip_check = true; // Skip the zip check, as there's no zip here.
      update_obj["data.assetsAvailable"] = false;
      var images = map(this.show.data.slideArray, s => {
        return {
          filename: s.file,
          name: s.file,
          source_id: show_key
        };
      });
      update_obj["data.images"] = images;
      // It needs a general "images" array!
      if (has_audio) {
        update_obj["data.audio.filename"] = "audio_hi.mp3.mp3";
        update_obj["data.audio.name"] = "audio_hi.mp3";
        update_obj["data.audio.source_id"] = show_key;
        update_obj["data.audio.deployed"] = false;
      }
      // Update on server.
      db.collection("editor_shows")
        .doc(show_key)
        .update(update_obj)
        .then(function() {
          console.log("updateForImportByUrl", "success");
          setTimeout(_v.send_importer_sns, 1000);
        });
    }
  }
};
</script>

<style lang="css" scoped></style>
